import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Alignment,
	Button,
	Classes,
	Dialog,
	FormGroup,
	InputGroup,
	Intent,
	Navbar,
	Checkbox,
	NumericInput,
} from '@blueprintjs/core';

import TextWithTooltip from '../TextWithTooltip';
import { AppToaster }  from '../AppToaster';

class AddEditChannel extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			id_channel:    props.item === null ? -1   : props.item.id_channel,
			internal_code: props.item === null ? ''   : props.item.internal_code,
			title:         props.item === null ? ''   : props.item.title,
			visible:       props.item === null ? true : props.item.visible,
			ord:           props.item === null ? 1    : props.item.ord,
			validation_failed_fields: [],
		};
	}
	
	render() {
		return <Dialog
			isOpen={true}
			usePortal={true}
			canOutsideClickClose={true}
			canEscapeKeyClose={true}
			onClose={() => this.props.closeAddEditItemDialog()}
			className='add-edit-channel-dialog'>
			<div className='flex flex-col flex-grow'>
				<Navbar fixedToTop={false} className='bp5-dark'>
					<Navbar.Group>
						<Navbar.Heading>Dodaj / uredi prodajni kanal</Navbar.Heading>
					</Navbar.Group>
					<Navbar.Group align={Alignment.RIGHT}>
						<Button minimal={true} icon='cross' onClick={() => this.props.closeAddEditItemDialog()} />
					</Navbar.Group>
				</Navbar>
				<div className={Classes.DIALOG_BODY}>
					<div className='flex flex-1 flex-col'>
						<FormGroup
							labelFor='add-edit-channel-dialog--internal_code'
							className={
								'flex-1 ' +
								(this.state.validation_failed_fields.indexOf('internal_code') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Oznaka'
								tooltip='Oznaka' />
							<InputGroup
								id='add-edit-channel-dialog--internal_code'
								value={this.state.internal_code}
								onChange={event => {
									if (event.target.value.length > 2) return;
									this.setState({
										internal_code: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-channel-dialog--title'
							className={
								'flex-1 ' +
								(this.state.validation_failed_fields.indexOf('title') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Naziv'
								tooltip='Naziv' />
							<InputGroup
								id='add-edit-channel-dialog--title'
								value={this.state.title}
								onChange={event => {
									this.setState({
										title: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-channel-dialog--visible'
							className='flex-1'>
							<TextWithTooltip
								label='Aktiven'
								tooltip='Aktiven' />
							<Checkbox checked={this.state.visible} onChange={event => {
								this.setState({ visible: event.target.checked });
							}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-channel-dialog--ord'
							className='flex-1'>
							<TextWithTooltip
								label='Vrstni red'
								tooltip='Vrstni red' />
							<NumericInput
								id='add-edit-channel-dialog--ord'
								value={this.state.ord}
								min={0}
								minorStepSize={1}
								onValueChange={val => {
									this.setState({
										ord: val,
									});
								}} />
						</FormGroup>
					</div>
				</div>
				<div className={Classes.DIALOG_FOOTER}>
					<div className={Classes.DIALOG_FOOTER_ACTIONS}>
						<Button
							minimal={true}
							onClick={() => this.props.closeAddEditItemDialog()}>
							Prekliči
						</Button>
						<Button
							intent={Intent.PRIMARY}
							onClick={() => {
								const new_item = {
									id_channel:    this.state.id_channel,
									internal_code: this.state.internal_code,
									title:         this.state.title,
									visible:       this.state.visible,
									ord:           this.state.ord,
									serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code,
								};
								
								// validate missing/empty fields
								const validation_failed_fields       = [];
								const validation_failed_field_titles = [];
								
								if (new_item.internal_code.length == 0) {
									validation_failed_fields.push('internal_code');
									validation_failed_field_titles.push('oznaka');
								}
								if (new_item.title.length == 0) {
									validation_failed_fields.push('title');
									validation_failed_field_titles.push('naziv');
								}
								
								this.setState({ validation_failed_fields });
								
								if (validation_failed_fields.length > 0) {
									AppToaster.show({
										message: <div>
											Za shranjevanje, izpolnite vsaj polja:
											<br />
											{validation_failed_field_titles.map(title => <div key={title}>{'• ' + title}</div>)}
										</div>,
										intent: 'danger',
										icon: 'issue'
									});
									return;
								}
								
								// save item
								this.props.closeAddEditItemDialog(new_item);
							}}>
							Shrani in zapri
						</Button>
					</div>
				</div>
			</div>
		</Dialog>;
	}
}
AddEditChannel.propTypes = {
	closeAddEditItemDialog: PropTypes.func,
	item: PropTypes.object,
};

export default AddEditChannel;
